import { FormControl, FormGroup } from '@nbg-globals/form-controls';
import { IBlockUserRequest } from './block-user';

export class BlockUserHelper {
	public static blockUserControls(): FormGroup<IBlockUserRequest> {
		return new FormGroup<IBlockUserRequest>({
			userName: new FormControl(null, { required: true }),
			vat: new FormControl(null, { required: true, func: validateTAX }),
		});
	}
}
export function validateTAX(value: string): boolean {
	if (!value) return true;
	value = value.trim();
	if (value.length == 0) {
		return true;
	}
	if (value.length < 8 || value.length > 9 || !isInt(value)) {
		return false;
	}

	value = padLeft(value, 9, '0');
	let sum1 = 0,
		digitValue = 0,
		chkDigit = 0,
		power = 2;
	digitValue = parseInt(value.substr(8, 1), 10);
	for (let i = 7; i >= 0; i--) {
		sum1 += parseInt(value.substr(i, 1), 10) * power;
		power = power * 2;
	}
	chkDigit = sum1 % 11;
	if (chkDigit == 10) {
		chkDigit = 0;
	}
	return chkDigit == digitValue;
}

function isInt(value: any): boolean {
	return /^-{0,1}\d+$/.test(value);
}

function padLeft(value: any, totalWidth: number, paddingChar: string) {
	if (value == null) return Array(totalWidth + 1).join(paddingChar);
	value = '' + value; // Cast to string
	if (value.length >= totalWidth) return value;
	return Array(totalWidth + 1 - value.length).join(paddingChar) + value;
}
